<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none">
    <rect width="24" height="24" rx="12" fill="#009E50" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14.6675 17.9422C15.5063 18.3091 15.8208 17.5403 15.8208 17.5403L18.04 6.3918C18.0226 5.64041 17.0091 6.09474 17.0091 6.09474L4.58501 10.97C4.58501 10.97 3.99089 11.1797 4.04331 11.5466C4.09574 11.9136 4.56754 12.0883 4.56754 12.0883L7.69539 13.1368C7.69539 13.1368 8.63899 16.2297 8.83121 16.8238C9.00595 17.4005 9.16322 17.4179 9.16322 17.4179C9.33796 17.4878 9.49522 17.3655 9.49522 17.3655L11.5222 15.5307L14.6675 17.9422ZM15.2092 8.36634C15.2092 8.36634 15.6461 8.10423 15.6286 8.36634C15.6286 8.36634 15.6985 8.40129 15.4714 8.64593C15.2617 8.85562 10.3165 13.294 9.6525 13.8881C9.60007 13.9231 9.56513 13.9755 9.56513 14.0454L9.37291 15.688C9.33796 15.8627 9.1108 15.8802 9.05838 15.7229L8.2371 13.0319C8.20215 12.9271 8.2371 12.8048 8.34194 12.7349L15.2092 8.36634Z"
      fill="white" />
  </svg>
</template>
